import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import ReduxToastr from 'react-redux-toastr';
import { ConnectedRouter } from 'react-router-redux';
import { APP_LOAD, REDIRECT } from '../constants/actionTypes';

import agent from '../agent';
import { store, history } from '../store';

import Home from './Home';
import Login from './Login';
import Register from './Register';
import RegisterThanks from './RegisterThanks';
import ForgotLogin from './ForgotLogin';
import ForgotLoginThanks from './ForgotLoginThanks';

const mapStateToProps = state => {
    return {
        appLoaded: state.common.appLoaded,
        appName: state.common.appName,
        currentUser: state.common.currentUser,
        redirectTo: state.common.redirectTo
    }
};

const mapDispatchToProps = dispatch => ({
    onLoad: (payload, token) =>
        dispatch({ type: APP_LOAD, payload, token, skipTracking: true }),
    onRedirect: () =>
        dispatch({ type: REDIRECT })
});

class App extends Component {
    componentWillReceiveProps(nextProps) {
        if (nextProps.redirectTo) {
            // this.context.router.replace(nextProps.redirectTo);
            store.dispatch(push(nextProps.redirectTo));
            this.props.onRedirect();
        }
    }

    componentWillMount() {
        const token = window.localStorage.getItem('jwt');
        if (token) {
            agent.requests.setToken(token);
        }
        // this.props.onLoad(token ? agent.Auth.current() : null, token);
    }

    render() {
        const { currentUser } = this.props;
        return (
            <div>
                <ReduxToastr />
                <ConnectedRouter history={history}>
                    <Switch>
                        <Route path="/Register" name="Register" component={Register} />
                        <Route path="/RegisterThanks" name="Register Thanks" component={RegisterThanks} />
                        <Route path="/ForgotLogin" name="Forgot Login" component={ForgotLogin} />
                        <Route path="/ForgotLoginThanks" name="Forgot Login Thanks" component={ForgotLoginThanks} />
                        {
                            currentUser ? <Route path="/" name="Home" component={Home} /> : <Route path="/" name="Login" component={Login} />
                        }
                    </Switch>
                </ConnectedRouter>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js